export class AlertData {
	public title: string;
	public message: string;
	public messages: string[];
	public type: string;
	public relogin: boolean;
}